import { Skeleton } from "@/shared/ui/Skeleton";

export function CustomerDetailSkeleton() {
  return (
    <div className="h-full flex flex-col bg-biz-bg" aria-busy aria-live="polite">
      {/* Header */}
      <div className="px-6 py-5 border-b border-biz-border bg-biz-surface">
        <div className="flex items-start gap-5">
          <Skeleton className="h-20 w-20 rounded-full" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-7 w-72" />
            <Skeleton className="h-4 w-96" />
            <div className="flex gap-2 mt-3">
              <Skeleton className="h-6 w-20 rounded-full" />
              <Skeleton className="h-6 w-24 rounded-full" />
              <Skeleton className="h-6 w-16 rounded-full" />
            </div>
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-14 w-14 rounded-biz-btn" />
            <Skeleton className="h-14 w-14 rounded-biz-btn" />
            <Skeleton className="h-14 w-14 rounded-biz-btn" />
            <Skeleton className="h-16 w-44 rounded-biz-btn" />
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 px-6 py-4 border-b border-biz-border">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-16 rounded-biz-card" />
        ))}
      </div>

      {/* Tabs */}
      <div className="px-6 border-b border-biz-border flex gap-2 py-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-24" />
        ))}
      </div>

      {/* Body */}
      <div className="flex-1 px-6 py-6">
        <div className="grid lg:grid-cols-12 gap-5">
          <div className="lg:col-span-8 space-y-5">
            <Skeleton className="h-24 rounded-biz-card" />
            <Skeleton className="h-48 rounded-biz-card" />
            <Skeleton className="h-32 rounded-biz-card" />
          </div>
          <div className="lg:col-span-4">
            <Skeleton className="h-72 rounded-biz-card" />
          </div>
        </div>
      </div>
    </div>
  );
}
